/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({ description, lang, meta, title }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
          }
        }
      }
    `
  )

  const schemaOrgWebPage = {
    "@context": "http://schema.org",
    "@type": "WebPage",
    url: site.siteMetadata.siteUrl,
    headline: "Accept PayNow Payments in Minutes",
    inLanguage: "en",
    mainEntityOfPage:  site.siteMetadata.siteUrl,
    description: "Maesh allows merchants to accept PayNow payments - merchants get lower fees, better conversions, and better payments experiences",
    name: "Hello Maesh",
    author: {
      "@id": "Hello Maesh",
    },
    copyrightHolder: {
      "@id": "Maesh Pte. Ltd.",
    },
    copyrightYear: "2020",
    creator: {
      "@id": "Hello Maesh",
    },
    publisher: {
      "@id": "Hello Maesh",
    },
    datePublished: "2020",
    image: {
      "@type": "ImageObject",
      url: "https://maesh.io/Logo-Maesh.png",
    },
  }
  
  const orgaCreator = {
    "@context": "http://schema.org",
    "@id": `${site.siteMetadata.siteUrl}`,
    "@type": "WebPage",
    address: {
      "@type": "PostalAddress",
      addressCountry: "Singapore",
      addressLocality: " 68 Circular Rd, #02-01, 049422",
    },
    name: "Hello Maesh",
    alternateName: "Maesh",
    description: site.siteMetadata.description,
    url:  site.siteMetadata.siteUrl,
    email: "hello@maesh.io",
    founder: "Michael Duyvesteijn",
    foundingDate: "2019",
    foundingLocation: "Singapore",
    image: {
      "@type": "ImageObject",
      url: "https://maesh.io/Logo-Maesh.png",
      height: "512",
      width: "512",
    },
    logo: {
      "@type": "ImageObject",
      url: "https://maesh.io/Logo-Maesh.png",
      height: "60",
      width: "60",
    },
    sameAs: [
      "https://www.linkedin.com/company/maesh-pte-ltd/",
    ],
  }
  

  const metaDescription = description || site.siteMetadata.description

  return (
    <>
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    />
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schemaOrgWebPage)}
      </script>
      <script type="application/ld+json">{JSON.stringify(orgaCreator)} 
      </script>
    </Helmet>
    </>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
